import { render, staticRenderFns } from "./AddressForm.vue?vue&type=template&id=4e155df4&scoped=true"
import script from "./AddressForm.vue?vue&type=script&lang=ts"
export * from "./AddressForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e155df4",
  null
  
)

export default component.exports